import { FormBuilder } from "../../../../../types/FormBuilderInterfaces";
import CustomToggle from "../../../../Drawers/Fields/CustomToggle";

interface Props {
  form: FormBuilder;
  setForm: (value: any, key: string) => void;
}

const SpamProtection = ({ form, setForm }: Props) => {
  const handleSetForm = (value: any, key: string) => {
    setForm({ ...form.SpamProtection, [key]: value }, "SpamProtection");
  };

  return (
    <div>
      <CustomToggle
        title="One Submission Per User"
        value={form?.SpamProtection?.LimitToOneSubmission ?? false}
        handleChange={(e) =>
          handleSetForm(e.target.checked, "LimitToOneSubmission")
        }
      />
      {/* <CustomToggle
        title="Enable reCAPTCHA"
        description="When enabled, the legal info will be placed in your widget footer as a requirement of Google."
        value={form?.SpamProtection?.ReCAPTCHA ?? false}
        handleChange={(e) => handleSetForm(e.target.checked, "ReCAPTCHA")}
      />
      <Alert
        color="warning"
        className="py-2 font-weight-bold d-flex align-items-center"
      >
        <i className="mdi mdi-timer-sand mr-2 text-lg" />
        reCaptcha feature not yet supported
      </Alert> */}
    </div>
  );
};

export default SpamProtection;
